import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isValidSKU, getOpenSizingSKUsFromProduct } from "@faire/retailer-visitor-shared/lib/SKUsUtils";
import { multipleSkuLabel, expandButtonLabel, collapseButtonLabel } from "@faire/retailer-visitor-shared/views/product/ProductDetails/SKUDisplayTexts";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { ExpandableText } from "@faire/web--source/ui/ExpandableText/ExpandableText";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackUpmarketProductDetailsPageSkuExpandableClick } from "@faire/web-api--source/events/upmarket/click/productDetailsPageSkuExpandable";
import React from "react";
export var SKUsText = function(param) {
    var product = param.product, selectedOption = param.selectedOption, productAddToCartState = param.productAddToCartState, actionWhenVisible = param.actionWhenVisible;
    if (productAddToCartState.isOpenSizingVariant) {
        return /*#__PURE__*/ _jsx(MultipleSKUs, {
            product: product,
            selectedOption: selectedOption,
            actionWhenVisible: actionWhenVisible
        });
    }
    return /*#__PURE__*/ _jsx(SingleSKU, {
        productAddToCartState: productAddToCartState,
        actionWhenVisible: actionWhenVisible
    });
};
var MultipleSKUs = function(param) {
    var product = param.product, selectedOption = param.selectedOption, actionWhenVisible = param.actionWhenVisible;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var skus = getOpenSizingSKUsFromProduct(product, selectedOption);
    var viewRef = useDoActionWhenVisible(actionWhenVisible);
    if (!skus) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Row, {
        ref: viewRef,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: multipleSkuLabel(strictLocalize)
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            }),
            /*#__PURE__*/ _jsx(ExpandableText, {
                content: skus,
                maxLines: 1,
                collapsible: true,
                expandButtonLabel: expandButtonLabel(strictLocalize),
                collapseButtonLabel: collapseButtonLabel(strictLocalize),
                expandCallback: function() {
                    trackUpmarketProductDetailsPageSkuExpandableClick("expand", skus);
                },
                collapseCallback: function() {
                    trackUpmarketProductDetailsPageSkuExpandableClick("collapse", skus);
                }
            })
        ]
    });
};
var SingleSKU = function(param) {
    var productAddToCartState = param.productAddToCartState, actionWhenVisible = param.actionWhenVisible;
    var _productAddToCartState_selectedOption;
    var sku = (_productAddToCartState_selectedOption = productAddToCartState.selectedOption) === null || _productAddToCartState_selectedOption === void 0 ? void 0 : _productAddToCartState_selectedOption.brand_code;
    var showSKUs = sku && isValidSKU(sku);
    var viewRef = useDoActionWhenVisible(actionWhenVisible);
    if (!showSKUs) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Typography, {
        ref: viewRef,
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "XN4WP0",
            defaultMessage: [
                {
                    type: 0,
                    value: "SKU "
                },
                {
                    type: 1,
                    value: "productSku"
                }
            ],
            values: {
                productSku: sku
            }
        })
    });
};
